import { IMessage } from '@v2/domains/chat/types/chat.types'

import {
  AssociatedBenefitContractLinkDto,
  BenefitLinkDto,
} from 'src/api/generated'

import { IGetTasksParams, ITask } from '../task/task.types'

export enum EscalationStatusEnum {
  CREATED = 'created',
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
  REVIEW = 'under review',
  SENT = 'sent to partner',
  PENDING = 'driver pending',
  RESOLVED = 'resolved',
}

export enum EscalationIssueEnum {
  BENEFIT = 'benefit',
  ELIGIBILITY = 'eligibility',
  ENROLLMENT = 'enrollment',
  EXEMPTION = 'exemption',
  BCF_GRIEANCES = 'BCF grievances',
  DB_GRIEANCES = 'DB grievances',
  DB_MARKETING = 'DB marketing',
  DB_APP = 'DB app assistance',
}

export const ISSUE_OPTIONS = [
  { value: EscalationIssueEnum.BENEFIT, label: 'Benefit' },
  { value: 'nonBenefit', label: 'Non-Benefit' },
]

export const NON_BENEFIT_OPTIONS = [
  { value: EscalationIssueEnum.ENROLLMENT, label: 'Enrollment Issue' },
  { value: EscalationIssueEnum.EXEMPTION, label: 'Activity Exemption Request' },
  { value: EscalationIssueEnum.BCF_GRIEANCES, label: 'The BCF Grievances' },
  { value: EscalationIssueEnum.DB_GRIEANCES, label: 'DB Grievances' },
  { value: EscalationIssueEnum.DB_MARKETING, label: 'DB Marketing' },
  { value: EscalationIssueEnum.DB_APP, label: 'DB App Assistance' },
]

export interface FormSubmissionDto {
  templateId?: string
  email?: string
  payload?: { steps: { fields: IFormField[] }[] }
  isCompleted?: boolean
  isReviewed?: boolean
  version?: string
  id?: string
  personId?: string
}
export interface IEscalation extends ITask {
  id: string
  formStatus: EscalationStatusEnum
  issue: EscalationIssueEnum
  form: FormSubmissionDto
  benefit: BenefitLinkDto | null
  benefitId: string | null
  abc: AssociatedBenefitContractLinkDto | null
  abcId: string | null
}

export interface IEscalationFilters extends IGetTasksParams {
  issue?: EscalationIssueEnum | null | 'nonBenefit'
  excludeIssue?: EscalationIssueEnum
  benefit?: string
  abc?: string
  formStatus?: EscalationStatusEnum
}

export type FormEscalationAttachments = {
  url?: string
  id?: string
  name: string
  size: number
  error?: string
  type: string
}[]

export type MutateEscalationData = Partial<
  Omit<
    IEscalation,
    'activityDate' | 'updatedAt' | 'createdAt' | 'activityDate' | 'issue'
  >
> & {
  updatedAt?: Date | null | string
  createdAt?: Date | null | string
  issue?: EscalationIssueEnum | null
  notes?: IMessage[]
  formFields?: { [key: string]: unknown } & { files: FormEscalationAttachments }
}

export interface IFormField {
  label: string
  name: string
  required: true
  type: 'textArea' | 'select' | 'multiSelect' | 'fileUploader' | 'datePicker'
  value: unknown
}
export interface IFormTemplate {
  isProcessabel?: boolean
  notifyEmails: {}
  url?: string
  type?: 'public' | 'private'
  name?: string
  version?: string
  userId?: string
  organizationId?: string
  id?: string
  payload: { steps: [{ fields: IFormField[] }] }
  processingStrategy?: string
}

export const ESCALATION_STATUS_OPTIONS = [
  {
    label: 'Created',
    value: EscalationStatusEnum.CREATED,
    disabled: true,
  },
  {
    label: 'Draft',
    value: EscalationStatusEnum.DRAFT,
    disabled: false,
  },
  {
    label: 'Submitted',
    value: EscalationStatusEnum.SUBMITTED,
    disabled: false,
  },
  {
    label: 'Under Review',
    value: EscalationStatusEnum.REVIEW,
    disabled: true,
  },
  {
    label: 'Sent to Partner / Provider',
    value: EscalationStatusEnum.SENT,
    disabled: true,
  },
  {
    label: 'Waiting for Driver Response',
    value: EscalationStatusEnum.PENDING,
    disabled: true,
  },
  {
    label: 'Resolved',
    value: EscalationStatusEnum.RESOLVED,
    disabled: true,
  },
]

export enum UpdateFormSubmitter {
  SAVE = 'save',
  SUBMIT = 'submit',
  SAVE_DRAFT = 'draft',
}
